import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { BasicRoleDto, SmartInvoicingRoleService } from 'src/app/proxy/roles';

@Component({
  selector: 'app-role-autocomplete',
  standalone: false,
  templateUrl: './role-autocomplete.component.html',
})
export class RoleAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  
  @Output() changeSelectedRole = new EventEmitter<BasicRoleDto>();
  roles: BasicRoleDto[];
  selectedRole: BasicRoleDto;

  private selectedRoleId: string;

  constructor(injector: Injector, private readonly _smartInvoicingRoleService: SmartInvoicingRoleService) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadRoles();
    this.onChangeSelectedRole();
  }

  async loadRoles(filter: AutoCompleteCompleteEvent = undefined): Promise<void> {
    try {
      this.showLoading();
      this.roles = (await firstValueFrom(this._smartInvoicingRoleService.getAllRolesByNameByName(filter?.query ?? undefined))) || [];
      this.setProviderSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedRole(): void {
    this.changeSelectedRole.emit(this.selectedRole);
  }
  
  onClearRole(): void {
    this.selectedRole = undefined;
    this.changeSelectedRole.emit(undefined);
  }

  setSelectedRolerId(roleId: string): void {
    this.selectedRoleId = roleId;
    if (this.roles && this.roles.length > 0) {
      this.selectedRole = this.roles.find(role => role.id === roleId);
    }
  }

  private setProviderSelectedIfCorrespond(): void {
    if (this.selectedRoleId) {
      this.selectedRole = this.roles.find(role => role.id === this.selectedRoleId);
    }
  }
}
